import * as yup from "yup";

import { adultRecommendChildProgramDOBValidationSchema } from "../../Dashboard/Providers/schema/newPatientValidation";
import {
  noInsuranceCarrierValidationSchemaFactory,
  yup_password_factory,
} from "../../../utils/yupSchemaUtils";

export const VALIDATION_SCHEMA = yup.object().shape({
  address: yup.object().shape({
    city: yup
      .string()
      .required("City is required")
      .matches(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/, "Enter a valid City")
      .nullable(),
    state: yup.string().required("State is required").nullable(),
    street: yup.string().required("Street is required").nullable(),
    zip_code: yup
      .string()
      .required("Zip code is required")
      .matches(/^\d{5}(?:[-\s]\d{4})?$/, "Enter a valid zip code")
      .nullable(),
  }),
  ConfirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("Password"), null], "Password does not match"),
  dob: adultRecommendChildProgramDOBValidationSchema.required("Date of birth is required"),
  emergency_contact_number: yup
    .string()
    .matches(/^\d{10}$/, "Contact Number must be a valid US number")
    .required("Mobile no. is required")
    .nullable(),
  emergency_contact_person: yup.string().required("This is required").nullable(),
  first_name: yup
    .string()
    .required("First Name is required")
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  gender: yup.string().required("Gender is required"),
  insurance: yup.object().shape({
    carrier: yup.string().required("Insurance Company is required”"),
    member_id: noInsuranceCarrierValidationSchemaFactory(
      "carrier",
      yup
        .string()
        .required("Member ID is required")
        .matches(/^[a-zA-Z0-9]*$/, "Enter a valid Member ID")
        .nullable(),
    ),
  }),
  last_name: yup
    .string()
    .required("Last Name is required")
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  mobile: yup
    .string()
    .matches(/^\d{10}$/, "Contact Number must be a valid US number")
    .required("Mobile no. is required"),
  Password: yup_password_factory(),
  Username: yup.string().email("Enter a valid email address").required("Email is required"),
});

export const GUARDIANSHIP_VALIDATION_SCHEMA = yup.object().shape({
  address: yup.object().shape({
    city: yup
      .string()
      .required("City is required")
      .matches(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/, "Enter a valid City")
      .nullable(),
    state: yup.string().required("State is required").nullable(),
    street: yup.string().required("Street is required").nullable(),
    zip_code: yup
      .string()
      .required("Zip code is required")
      .matches(/^\d{5}(?:[-\s]\d{4})?$/, "Enter a valid zip code")
      .nullable(),
  }),
  ConfirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("Password"), null], "Password does not match"),
  dob: adultRecommendChildProgramDOBValidationSchema.required("Date of birth is required"),
  emergency_contact_number: yup
    .string()
    .matches(/^\d{10}$/, "Contact Number must be a valid US number")
    .required("Mobile no. is required")
    .nullable(),
  emergency_contact_person: yup.string().required("This is required").nullable(),
  first_name: yup
    .string()
    .required("First Name is required")
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  gender: yup.string().required("Gender is required"),
  insurance: yup.object().shape({
    carrier: yup.string(),
    member_id: noInsuranceCarrierValidationSchemaFactory(
      "carrier",
      yup
        .string()
        .when("carrier", (value, schema) =>
          value !== undefined ? schema.required("Member ID is required") : schema,
        )
        .matches(/^[a-zA-Z0-9]*$/, "Enter a valid Member ID")
        .nullable(),
    ),
  }),
  last_name: yup
    .string()
    .required("Last Name is required")
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  mobile: yup
    .string()
    .matches(/^\d{10}$/, "Contact Number must be a valid US number")
    .required("Mobile no. is required"),
  Password: yup_password_factory(),
  Username: yup.string().email("Enter a valid email address").required("Email is required"),
});
